import React from 'react';
import { Carousel } from 'antd';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

interface HeaderCarouselProps {
  images: string[];
  mainTitle?: string;
  subTitle?: string;
}

const HeaderCarousel: React.FC<HeaderCarouselProps> = ({
  images = [],
  mainTitle,
  subTitle
}) => {
  const { t } = useTranslation('common');
  
  // ใช้ค่าจาก i18n หรือใช้ค่า default ถ้าไม่ได้กำหนด
  const displayMainTitle = mainTitle || t('headerCarousel.mainTitle');
  const displaySubTitle = subTitle || t('headerCarousel.subTitle');

  // แปลงข้อความที่มี \n เป็น <br/>
  const formattedMainTitle = displayMainTitle.split('\n').map((line, i) => (
    <React.Fragment key={i}>
      {line}
      {i < displayMainTitle.split('\n').length - 1 && <br />}
    </React.Fragment>
  ));

  const formattedSubTitle = displaySubTitle.split('\n').map((line, i) => (
    <React.Fragment key={i}>
      {line}
      {i < displaySubTitle.split('\n').length - 1 && <br />}
    </React.Fragment>
  ));

  return (
    <div style={{ position: 'relative' }}>
      <Carousel 
        autoplay 
        draggable 
        dots={false} 
        arrows={false}
        autoplaySpeed={10000}
        lazyLoad="progressive"
        style={{ marginTop: '-120px' }}
      >
        {images.map((imagePath, index) => (
          <div key={index}>
            <div style={{ height: '700px', position: 'relative', width: '100%' }}>
              <Image
                src={imagePath}
                alt={t('headerCarousel.imageAlt', { index: index + 1 })}
                fill
                priority={index === 0}
                sizes="100vw"
                style={{
                  objectFit: 'cover',
                  objectPosition: 'center 45%'
                }}
              />
            </div>
          </div>
        ))}
      </Carousel>
      
      {/* ข้อความทับบน Carousel */}
      <div 
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 10,
          textAlign: 'left',
          width: '80%',
          maxWidth: '1496px',
        }}
      >
        <p 
          style={{
            color: 'white',
            fontSize: '57px',
            fontWeight: '500',
            margin: 0,
            lineHeight: '120%',
          }}
        >
          {formattedMainTitle}
        </p>
        <p 
          style={{
            color: 'white',
            fontSize: '19px',
            fontWeight: '400',
            margin: 0,
          }}
        >
          {formattedSubTitle}
        </p>
      </div>
    </div>
  );
};

export default HeaderCarousel;